import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { getStartDateForSchoolYear } from '../../../../../../../helpers/calendar/calendar';
import { SchoolStudent } from 'Src/models/schoolStudent';
import { ReportActions, ReportDateRange, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  student: SchoolStudent[];
  activeSchoolId: string;
}

const startOfDay = (date: Date) => new Date(new Date(date).setHours(0, 0, 1, 0));
const endOfDay = (date: Date) => new Date(new Date(date).setHours(23, 59, 59, 999));
const schoolYearRange = () => {
  const now = new Date();
  return { from: startOfDay(getStartDateForSchoolYear(now)), to: endOfDay(now) };
};

export const ClubListForStudentReportForm = ({ onCloseClick, onSubmit, student, activeSchoolId }: Props) => {
  const [schoolData, setSchoolData] = React.useState<any>(null);

  React.useEffect(() => {
    fetch('/dist/images/mis/misIntegrationSchoolsList.json')
      .then(response => response.json())
      .then(data => setSchoolData(data.find(item => item.schoolSITId === activeSchoolId)))
      .catch(error => console.error('Error loading JSON:', error));
  }, [activeSchoolId]);

  const range = schoolYearRange();
  const initialValues = {
    dateFrom: range.from,
    dateTo: range.to,
    isPrintFormName: false,
    isPrintAgeGroup: false,
    isPrintHouse: false,
    isPrintPP: false,
    isPrintSEN: false,
    isPrintFSM: false,
    isPrintAttendance: true
  };

  return (
    <Formik enableReinitialize initialValues={initialValues} onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_LIST_FOR_STUDENT)}>
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <div className="eReportForm__scroll">
          <ReportDescription>View all clubs relating to the selected student.</ReportDescription>
          <ReportSection number={1} title="Reporting period" hint="Choose the date range included in the report." required>
            <ReportDateRange
              dateFrom={values.dateFrom}
              dateTo={values.dateTo}
              onChangeFrom={date => {
                setFieldValue('dateFrom', date);
                if (values.dateTo && values.dateTo < date) setFieldValue('dateTo', date);
              }}
              onChangeTo={date => setFieldValue('dateTo', date)}
            />
          </ReportSection>

          <ReportSection number={2} title="Output" hint="Choose the information included in the report."><ReportToggleList><ReportToggle name="isPrintAttendance" label="Show attendance rate" hint="Show average attendance rate for each club." value={values.isPrintAttendance} onChange={value => setFieldValue('isPrintAttendance', value)} /></ReportToggleList></ReportSection>

          {(schoolData && (schoolData.studentsPPInfo === 1 || schoolData.studentsSENInfo === 1 || schoolData.studentsFSMInfo === 1)) && (
            <ReportSection number={3} title="Student information" hint="Choose additional student information to include."><ReportToggleList>
              {schoolData.studentsPPInfo === 1 && <ReportToggle name="isPrintPP" label="Show PP" hint="Show information relating to PP." value={values.isPrintPP} onChange={value => setFieldValue('isPrintPP', value)} />}
              {schoolData.studentsSENInfo === 1 && <ReportToggle name="isPrintSEN" label="Show SEN" hint="Show information relating to SEN." value={values.isPrintSEN} onChange={value => setFieldValue('isPrintSEN', value)} />}
              {schoolData.studentsFSMInfo === 1 && <ReportToggle name="isPrintFSM" label="Show FSM" hint="Show information relating to FSM." value={values.isPrintFSM} onChange={value => setFieldValue('isPrintFSM', value)} />}
            </ReportToggleList></ReportSection>
          )}
          </div>
          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
};
